/**
 * Form Dynamic Class
 */
class FormDynamic {
  /**
   * Create new dynamic form
   * @param {HTMLElement} input Dynamic input trigger
   */
  constructor (input) {
    this.input = input
    this.id = input.id
    this.fields = document.querySelectorAll(`[data-form-dynamic-id="${this.id}"]`)

    this.changeFields()
    this.input.addEventListener('change', () => this.changeFields())
  }

  /**
   * Loop through all fields and set their status
   */
  changeFields () {
    for (let i = 0; i < this.fields.length; i++) {
      this.setStatus(this.fields[i])
    }
  }

  /**
   * Check and set status for specific field
   * @param {HTMLElement} field Form field
   */
  setStatus (field) {
    if (field.dataset.formDynamicValue === this.input.value) {
      field.hidden = false
    } else {
      field.hidden = true
    }
  }
}

export default FormDynamic
